import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@app/index';
import { ContextualisedUser } from './contexts/user/ContextualisedUser';

if (process.env.NODE_ENV !== 'production') {
  const config = {
    rules: [
      {
        id: 'color-contrast',
        enabled: false,
      },
    ],
  };
  // eslint-disable-next-line @typescript-eslint/no-var-requires, no-undef
  const axe = require('react-axe');
  axe(React, ReactDOM, 1000, config);
}

console.log(`Environment: ${process.env.REACT_APP_NODE_ENV}`);
console.log(`API URL: ${process.env.REACT_APP_URL}`);
console.log(`BACKEND URL: ${process.env.REACT_APP_BACKENDAPI_URL}`);

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

root.render(
  <React.StrictMode>
    <ContextualisedUser>
      <App />
    </ContextualisedUser>
  </React.StrictMode>,
);
